import { type ZodSchema } from 'zod'

export const isObject = <T>(obj: unknown, schema: ZodSchema<T>): obj is T => schema.safeParse(obj).success

export const isPlainObject = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value)
